<section *ngFor="let area of dashboardAreas">
    <mat-toolbar class="dashboard-toolbar">
        <button mat-icon-button>
            <mat-icon [svgIcon]="getAreaIcon(area)"></mat-icon>
        </button>
        <span>
                {{getTag(area)}}
            </span>
        <div class="fill-space"></div>
        <div>
            <a mat-button
               *ngIf="area.areaId"
               [uiSref]="monitoringState"
               [uiParams]="getLinkParams(area)"
               title="Go To Monitoring">
                <mat-icon class="area-menu-icon">settings_input_antenna</mat-icon>
                <span class="smaller-text">
                        MONITORING
                    </span>
            </a>
        </div>
        <div>
            <a mat-button
               *ngIf="area.areaId"
               [uiSref]="controlsState"
               [uiParams]="getLinkParams(area)"
               title="Go To Controls">
                <mat-icon class="area-menu-icon">build</mat-icon>
                <span class="smaller-text">
                        CONTROLS
                    </span>
            </a>
        </div>
        <button mat-button
                (click)="toggleArea(area)"
                aria-label="Toggle Section">
            <mat-icon>
                {{ getExpandIcon(area) }}
            </mat-icon>
        </button>
    </mat-toolbar>

    <div *ngIf="!area.$hidden"
         class="animate-if padding-10">
        <div fxLayout="row wrap"
             fxLayout.lt-sm="column">
            <dl-dashboard-device *ngFor="let device of area.devices"
                                [device]="device"></dl-dashboard-device>
        </div>
    </div>
</section>
